// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Sibling imports
const { withButton } = require('./base')
const { withModelToggle } = require('./model-toggle')

const CapsuleButton = withButton('CapsuleButton')
const CircleButton = withButton('CircleButton')

module.exports = {
  CapsuleButton,
  CircleButton,
  ...createModelToggleButtonComponents({
    ArticleAdd: modelTypes.ARTICLE,
    CollectionSubscribe: modelTypes.MIX,
    InterestFollow: modelTypes.INTEREST,
    UserFollow: modelTypes.USER
  }, {
    CapsuleButton,
    CircleButton
  })
}

function createModelToggleButtonComponents(modelTypesByName, buttonComponentsByName) {
  const result = {}
  for (let modelTypeName in modelTypesByName) {
    const modelType = modelTypesByName[modelTypeName]
    for (let buttonComponentName in buttonComponentsByName) {
      const buttonComponent = buttonComponentsByName[buttonComponentName]
      const combinedComponentName = `${modelTypeName}${buttonComponentName}`
      result[combinedComponentName] = withModelToggle(modelType, buttonComponent)
    }
  }
  return result
}
